import React from 'react';
import { MapPin, CheckCircle2, Award, ShieldCheck, Check } from 'lucide-react';

export default function About() {
  return (
    <section id="om-os" className="py-24 bg-slate-50 border-y border-slate-200/80 relative overflow-hidden">
      {/* Decorative background blur */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/3 rounded-full blur-3xl pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-stretch">
          
          {/* Left Column: Image with Stats overlay */}
          <div className="lg:col-span-5 relative min-h-[350px] lg:min-h-full overflow-hidden">
            <div className="absolute inset-0 bg-slate-100">
              <img
                src="https://assets.auxodev.dk/assets/e2460b72-5386-46d7-9851-4a7b448e2c89/9cec28cf-d5e2-477b-8aba-7a779bf4e54c.jpg"
                alt="Balsby Montage Værksted og Arbejde"
                className="w-full h-full object-cover transition-transform duration-500 hover:scale-102"
              />
            </div>
          </div>

          {/* Right Column: Text Content */}
          <div className="lg:col-span-7 lg:pl-8 mt-8 lg:mt-0">
            <span className="text-xs font-bold tracking-[0.2em] text-black uppercase block">
              Hvem er vi?
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-black tracking-tight text-black uppercase">
              Balsby Montage ApS
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed text-base">
              Balsby Montage ApS er en professionel og alsidig montage- og smedevirksomhed med base i Årre. Vi har specialiseret os i at levere skræddersyede løsninger af højeste kvalitet til både erhverv, industri, landbrug og private.
            </p>
            <p className="mt-4 text-slate-500 leading-relaxed text-sm">
              Vores fundament bygger på solidt håndværk, teknisk snilde og en kompromisløs tilgang til præcision. Vi forstår, at enhver opgave kræver sin helt egen unikke tilgang, og vi sætter en stor ære i at levere til tiden og overholde alle aftaler.
            </p>

            {/* Value Props */}
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-center gap-3">
                <div className="text-black">
                  <Check className="h-6 w-6 stroke-[3]" />
                </div>
                <div>
                  <h4 className="font-medium text-black text-lg sm:text-xl uppercase">Svejsearbejde</h4>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="text-black">
                  <Check className="h-6 w-6 stroke-[3]" />
                </div>
                <div>
                  <h4 className="font-medium text-black text-lg sm:text-xl uppercase">Specialudvikling</h4>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="text-black">
                  <Check className="h-6 w-6 stroke-[3]" />
                </div>
                <div>
                  <h4 className="font-medium text-black text-lg sm:text-xl uppercase">Pålidelig Montage</h4>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="text-black">
                  <Check className="h-6 w-6 stroke-[3]" />
                </div>
                <div>
                  <h4 className="font-medium text-black text-lg sm:text-xl uppercase">Lokalt Forankret</h4>
                </div>
              </div>
            </div>

            {/* Info Box */}
            <div className="mt-10 p-6 bg-white border border-slate-200/80 shadow-sm flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div>
                <span className="text-xs text-slate-500 uppercase tracking-wider block">Har du et projekt i tankerne?</span>
                <span className="text-lg font-bold text-slate-900 block mt-1">Lad os tage en uforpligtende snak</span>
              </div>
              <a
                href="tel:+4593872382"
                className="bg-[#487aad] hover:bg-[#3b6591] text-white font-bold px-6 py-3 text-sm transition-all duration-200 shadow-md shadow-[#487aad]/10"
              >
                Ring: 93 87 23 82
              </a>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}
